/** In-memory ID JWT for API Gateway Cognito authorizer (Bearer). Updated by AuthContext. */
let idToken = null;

export function setCognitoIdToken(token) {
  idToken = token || null;
}

export function getCognitoIdToken() {
  return idToken;
}
